<div>
  <app-base-report *ngIf="tableData"
                   [reportName]="'Products'"
                   [defaultColumns]="displayedColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="tableData"
                   [rowsLength]="numPages"
                   [hasCheckboxes]="false"
                   [filterFields]="filterFields"
                   (filterTrigger)="filter($event)"
                   [hasDateRangeFilter]="true"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChange($event)"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="fetchService"
                   [rowActions]="rowActions"
                   (assignedBusinessesFilterChanged)="assignedBusinessesFilterChanged($event)"
                   (rowActionClicked)="rowActionClicked($event)"></app-base-report>
</div>
